import { render, staticRenderFns } from "./Reversal.vue?vue&type=template&id=3a7042aa&"
import script from "./Reversal.vue?vue&type=script&lang=js&"
export * from "./Reversal.vue?vue&type=script&lang=js&"
import style0 from "./Reversal.vue?vue&type=style&index=0&id=3a7042aa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports